module.exports = __webpack_public_path__ + "static/media/05D17E9E-4C4E-4CC7-8A86-445CF86F904C.79bac2f0.JPG";